import React, { useCallback } from "react";
import { LongTextLabel } from "@sscs/ui";
import { Dialog } from "Components";
import { useGetWhoamiQuery } from "Services";
import { PersonalAccessTokenInfo } from "Types";
import { useRevokeAccessToken } from "../../hooks";
import DialogWarning from "../DialogWarning/DialogWarning";
import styles from "./revokeAccessToken.module.scss";

type RevokeAccessTokenProps = {
  isOpen: boolean;
  onClose: () => void;
  token: PersonalAccessTokenInfo;
};

const RevokeAccessToken = ({
  isOpen,
  onClose,
  token,
}: RevokeAccessTokenProps): React.JSX.Element => {
  const { data: whoami } = useGetWhoamiQuery();

  const { handleRevokeAccessToken } = useRevokeAccessToken({
    tokenDigest: token.digest,
    userId: whoami?.user_id,
    errorMessage: "Could not revoke personal access token",
    successMessage: "Personal access token revoked",
  });

  const handleRevokeClick = useCallback(() => {
    handleRevokeAccessToken();
    onClose();
  }, [handleRevokeAccessToken, onClose]);

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Revoke personal access token"
      confirmText="Revoke"
      confirmButtonColor="secondary"
      cancelButtonColor="primary"
      onConfirm={handleRevokeClick}
      onCancel={onClose}
    >
      <div className={styles.content}>
        Are you sure you want to revoke &quot;
        <LongTextLabel label={token.name} className={styles["revoke-token"]} />
        &quot; token?
      </div>
      <DialogWarning
        status="warning"
        title="Warning!"
        byline="Applications or services that use this API key will no longer be able to access the associated resources or data."
      />
    </Dialog>
  );
};

export default RevokeAccessToken;
